/**************
 Global
 ***************/

// get index of a specific element
function getElIndex(el) {
  let i;
  for (i = 0; (el = el.previousElementSibling); i++);
  return i;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  }).then(function (data) {
    return data.json();
  });
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  }).then(function (data) {
    return data.json();
  });
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  }).then(function (data) {
    return data.json();
  });
}

//download product
function downloadProduct(handle) {
  return fetch(`/products/${handle}.js`)
    .then(function (data) {
      return data.json();
    })
    .then(function (data) {
      return data;
    })
    .catch((error) => {
      return false;
    });
}

// print price ($51.27 = 5127)
function price(amount) {
  let total = (parseFloat(amount) / 100).toFixed(2);
  return `$${total.replace(".00", "")}`;
}

// Smooth in-page anchors
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const DURATION = window.matchMedia("(max-width: 989px)").matches
    ? 1000
    : 1000;
  var rafId = null;

  function doScrolling(elementY, duration) {
    var startingY = window.pageYOffset;
    var diff = elementY - startingY;
    var start;

    if (rafId) cancelAnimationFrame(rafId);

    window.requestAnimationFrame(function step(timestamp) {
      if (!start) start = timestamp;
      var time = timestamp - start;
      var percent = Math.min(time / duration, 1);

      // Must be auto/instant: otherwise CSS scroll-behavior fights each frame
      window.scrollTo({
        top: startingY + diff * percent,
        left: 0,
        behavior: "auto",
      });

      if (time < duration) {
        rafId = window.requestAnimationFrame(step);
      } else {
        rafId = null;
      }
    });
  }

  document.addEventListener("click", function (event) {
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href || href === "#") return;

    const id = href.slice(1);
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();

    const pad =
      parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) ||
      0;
    doScrolling(
      window.pageYOffset + target.getBoundingClientRect().top - pad,
      DURATION,
    );

    if (history.replaceState) history.replaceState(null, "", "#" + id);
  });
})();
